import { FALLBACK_LANG, FALLBACK_REGION, regions } from './regions';

const getLangCodeForRegion = (region) => {
  const countryCode = region || FALLBACK_REGION;
  const countryLang = regions.find(element => element.id === countryCode) || {
    language: FALLBACK_LANG,
  };

  return `${countryLang.language}-${countryCode}`;
};

export default getLangCodeForRegion;
